import { KeyboardEvent } from 'react';

const allowedKeysForNumbers = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
];

const navigationKeys = [
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'Tab',
];

export const allowOnlyPercentages = (
  event: KeyboardEvent<HTMLInputElement>
) => {
  const { key, currentTarget } = event;
  const value = currentTarget.value;

  // ✅ Allow Ctrl/Cmd shortcuts
  if (event.ctrlKey || event.metaKey) return;

  if (navigationKeys.includes(key)) return;

  // Prevent any non-numeric characters except decimal point
  if (!/^[0-9.]$/.test(key)) {
    event.preventDefault();
    return;
  }

  // Allow only one decimal point
  if (key === '.' && value.includes('.')) {
    event.preventDefault();
    return;
  }

  // Ensure valid numeric value after key press
  const newValue = value + key;
  const numericValue = parseFloat(newValue);

  // Prevent values over 100 or more than 2 decimals
  if (
    numericValue > 100 ||
    (newValue.includes('.') && newValue.split('.')[1].length > 2)
  ) {
    event.preventDefault();
  }
};

export const allowOnlyNumbers = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  const { key, currentTarget } = event;
  // Prevent default for any key that is not allowed
  const allowedKeys = [...allowedKeysForNumbers, ...navigationKeys];
  const value = currentTarget.value;

  // ✅ Allow Ctrl/Cmd shortcuts
  if (event.ctrlKey || event.metaKey) return;

  // Allow one decimal point, but prevent a second one
  if (key === '.' && (value.includes('.') || !value)) {
    event.preventDefault();
  } else if (key === '.' || allowedKeys.includes(key)) {
    // Allow the decimal point or the allowed numeric keys
    return;
  } else {
    // Prevent any other key
    event.preventDefault();
  }
};

//without accepting dots
export const allowOnlyNumbersWithoutDots = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  const { key } = event;

  // Define allowed keys
  const allowedKeys = [...allowedKeysForNumbers, ...navigationKeys];

  // ✅ Allow Ctrl/Cmd shortcuts
  if (event.ctrlKey || event.metaKey) return;

  // Allow only numbers and navigation keys
  if (!allowedKeys.includes(key)) {
    event.preventDefault();
  }
};
export const allowOnlyNumbersUptoN =
  (limit?: number) => (event: KeyboardEvent<HTMLInputElement>) => {
    const { key, currentTarget } = event;
    const value = currentTarget.value;

    // ✅ Allow Ctrl/Cmd shortcuts
    if (event.ctrlKey || event.metaKey) return;
    if (navigationKeys.includes(key)) return;

    // Prevent any non-numeric characters except decimal point
    if (!/^[0-9.]$/.test(key)) {
      event.preventDefault();
      return;
    }

    // Allow only one decimal point
    if (key === '.' && value.includes('.')) {
      event.preventDefault();
      return;
    }

    // Ensure valid numeric value after key press
    const newValue = value + key;
    // Prevent values  more than limit or by default 4 decimals
    if (
      newValue.includes('.') &&
      newValue.split('.')[1].length > (limit ?? 4)
    ) {
      event.preventDefault();
    }
  };
